import Confirmation from './confirmation-container';

export default Confirmation;
